export enum ComparisonType {
  Equals = 'Equal',
  NotEqual = 'NotEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Contains = 'Contains',
  NotContains = 'NotContains',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  InRange = 'InRange',
  In = 'In',
  NotIn = 'NotIn',
  Like = 'Like',
  Blank = 'Blank',
  NotBlank = 'NotBlank',
}

export enum OdataOperator {
  'Equal' = ' eq ',
  'NotEqual' = ' ne ',
  'GreaterThan' = ' gt ',
  'GreaterThanOrEqual' = ' ge ',
  'LessThan' = ' lt ',
  'LessThanOrEqual' = ' le ',
  'Contains' = 'substringof',
  'NotContains' = 'not substringof',
  'StartsWith' = 'startswith',
  'EndsWith' = 'endswith',
  'InRange' = 'InRange',
  'Not' = ' not ',
  'Blank' = ' eq null ',
  'NotBlank' = ' ne null ',
}
